
import { useI18n } from 'vue-i18n';
import { defineComponent, ref } from 'vue'
import AuthModule from './store/auth.module'
import user from './model/user'
import { useRoute } from 'vue-router';
import useQuasar from 'quasar/src/composables/use-quasar.js';
import settingsItems from './utils/settingsItems'
import LogsDialog from './components/usersettings/LogsDialog.vue';
import { useLogsPanel } from './composables/useLogsPanel';

export default defineComponent({

  components: {
    LogsDialog
  },

  setup() {
    const { t } = useI18n({ useScope: 'global' })
    const route = useRoute()
    const q = useQuasar()
    const leftDrawerOpen = ref(false)
    let options = ref(settingsItems)
    const logsDialog = ref(false)
    const { isOpen, open, close } = useLogsPanel()

    return {
      route,
      t,
      q,
      leftDrawerOpen,
      options,
      logsDialog,
      isOpen,
      openLogs: open,
      closeLogs: close
    }
  },

  computed: {

    currentUser(): user {
      console.log('computed')

      return AuthModule.currentUser;
    },

    showAdminBoard(): boolean {
      if (this.currentUser && this.currentUser['role'] && this.route.name != 'authenticate') {
        return this.currentUser['role'] == 'ADMIN';
      }
      return false;
    },
    showHomeBoard(): boolean {

      if (this.currentUser && this.currentUser['role'] && this.route.name != 'authenticate') {
        return true;
      }
      return false;
    },
    showScreens(): boolean {
      if (this.currentUser && this.currentUser['role'] && this.route.name != 'authenticate') {
        return true;
      }
      return false;
    },
    showProfile(): boolean {
      if (this.currentUser && this.currentUser['role'] && this.route.name != 'authenticate') {
        return (this.currentUser['role'] == 'MODERATOR' || this.currentUser.role == "ADMIN");
      }
      return false;
    },
    notAuthenticate(): boolean {
      if (this.route.name == 'authenticate')
        window.removeEventListener('beforeunload', this.leaving)
      else
        window.addEventListener('beforeunload', this.leaving);
      if (this.route.name != 'authenticate') {
        return true
      }
      return false;
    }

  },
  watch: {
    currentUser(newValue) {
      console.log(`yes, computed property changed: ${newValue}`);
    },

  },
  mounted(): void {
    console.log("mounted")
  },
  created(): void {
    console.log("created")
    window.addEventListener('beforeunload', this.leaving);
  },
  methods: {

    toggleLeftDrawer(): void {
      this.leftDrawerOpen = !this.leftDrawerOpen
    },

    isItReallyMobile(): boolean {
      return this.q.screen.width < 700;
    },

    leaving(e) {
      e.returnValue = "";
      try {
        //localStorage.removeItem("doneLogout");
        AuthModule.clientdisconnect();
        //window.alert("Sure to leave?");
      } catch (e) {
        console.log(`Error while logging out: ${e}`);
      }
    },
    async logOut() {

      await AuthModule.signout();
      this.$router.push('/login');
      console.log('logout', this.currentUser)
    }
  }
})
